export const THREE_DS_FORM_VALUES_STORAGE_KEY = 'deposit_3ds_form_values'
export const THREE_DS_SESSION_ID_STORAGE_KEY = 'deposit_3ds_session_id'
export const THREE_DS_SESSION_RESULT_STORAGE_KEY = 'deposit_3ds_session_result'
export const THREE_DS_CALLBACK_READY_STORAGE_KEY = 'deposit_3ds_callback_ready'

export const THREE_DS_MESSAGE_DEPOSIT_RESULT = 'threeDS:deposit-result'
export const THREE_DS_MESSAGE_AUTH_FAILED = 'threeDS:auth-failed'
export const THREE_DS_MESSAGE_DEPOSIT_FAILED = 'threeDS:deposit-failed'
export const THREE_DS_POPUP_WINDOW_NAME = 'tm_deposit_3ds_popup'
